import { formatDatetime } from '@/utils/datetimes/formatting';
import moment from 'moment';

export enum DocumentType {
    REQUISITION = 'REQUISITION',
    PRESCRIPTION = 'PRESCRIPTION',
    CONSENT = 'CONSENT',
    RESULT = 'RESULT',
    SHIPPING_LABEL = 'SHIPPING_LABEL',
    IMMUNIZATION_RECORD = 'IMMUNIZATION_RECORD',
    SAMPLE = 'SAMPLE',
    PATIENT_UPLOAD = 'PATIENT_UPLOAD',
    UNKNOWN = 'UNKNOWN',
}

export const renderDocumentType = (documentType: DocumentType) => {
    switch (documentType) {
        case DocumentType.REQUISITION:
            return 'Requisition';
        case DocumentType.PRESCRIPTION:
            return 'Prescription';
        case DocumentType.CONSENT:
            return 'Consent';
        case DocumentType.RESULT:
            return 'Result';
        case DocumentType.SHIPPING_LABEL:
            return 'Shipping Label';
        case DocumentType.IMMUNIZATION_RECORD:
            return 'Immunization Record';
        case DocumentType.SAMPLE:
            return 'Sample';
        case DocumentType.PATIENT_UPLOAD:
            return 'Patient Upload';
        case DocumentType.UNKNOWN:
            return 'Unknown';
        default:
            throw new Error(`Unknown document type: ${documentType as string}`);
    }
};

export const renderDocumentName = ({
    document: { documentType, createdAt },
    timezone,
}: {
    document: { documentType: DocumentType; createdAt: Date };
    timezone: string | null;
}) => `${renderDocumentType(documentType)} @ ${formatDatetime(moment(createdAt), timezone)}`;
